/** Mirrors backend GUARDED_NO_GENERAL_CREATE_ROLES plus TEACHER (cabinet UI policy). */
export const GUARDED_NO_GENERAL_CREATE_ROLES = new Set([
  'DEPARTMENT_HEAD',
  'DEPARTMENT_ASSISTANT',
  'DEPARTMENT_LAB',
  'LEARNER',
  'STUDENT',
  'COURSE_STUDENT',
  'PROJECT_MEMBER',
  'TEACHER',
]);

export const GATEWAY_ROUTE_IDS = ['RESEARCH', 'AUTHOR', 'EDITORIAL', 'CONTENT'] as const;

export function canOpenRequestGateway(roleCode?: string | null): boolean {
  if (!roleCode) return true;
  return !GUARDED_NO_GENERAL_CREATE_ROLES.has(roleCode);
}

export function isGatewayRouteAllowed(
  roleCode: string | null | undefined,
  routeId: string,
  routesAllowed?: string[] | null
): boolean {
  if (!canOpenRequestGateway(roleCode)) return false;
  if (routesAllowed) return routesAllowed.includes(routeId);
  // Without catalog payload, only non-guarded roles may open any of the four.
  return GATEWAY_ROUTE_IDS.includes(routeId as (typeof GATEWAY_ROUTE_IDS)[number]);
}

export function gatewayRoleLabel(roleCode?: string | null): string | undefined {
  if (!roleCode) return undefined;
  const labels: Record<string, string> = {
    SYSTEM_OWNER: 'Владелец системы',
    OPERATIONS_PARTNER: 'Операционный партнёр',
    RESEARCH_PARTNER: 'Научный партнёр',
    MENTOR_PARTNER: 'Научный партнёр',
    RESEARCHER: 'Исследователь',
    CLIENT: 'Клиент',
    AUTHOR: 'Автор / соавтор',
    PROJECT_EDITOR: 'Редактор проекта',
    LEARNER: 'Докторант',
    STUDENT: 'Обучающийся',
    COURSE_STUDENT: 'Обучающийся',
    TEACHER: 'Преподаватель',
    PROJECT_MEMBER: 'Участник проекта',
    DEPARTMENT_HEAD: 'Руководитель подразделения',
    DEPARTMENT_ASSISTANT: 'Лаборант кафедры',
    DEPARTMENT_LAB: 'Лаборант кафедры',
  };
  return labels[roleCode] || roleCode;
}
